"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var tradeInDetailsStyles = makeStyles_1.default(function (_a) {
    var palette = _a.palette, typography = _a.typography;
    return ({
        wrapper: {
            borderTop: "1px solid " + palette.primaryDisabled.main,
            padding: '20px 0',
        },
        title: {
            fontFamily: typography.fontFamily2,
            paddingBottom: '20px',
        },
        element: {
            fontFamily: typography.fontFamily,
            padding: '2px 0',
        },
        titleContent: {},
        elementContent: {},
        titleRow: {},
        makeRow: {},
        modelRow: {},
        variantRow: {},
        registrationNumberRow: {},
        colourRow: {},
        yearRow: {},
        mileageRow: {},
        commentRow: {},
    });
}, { name: 'GqlSummary_TradeIn' });
exports.default = tradeInDetailsStyles;
